export default "__VITE_ASSET__Dm5kSwAf__"